import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogHeader } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface DialogWrapperProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReset: () => void;
  children: React.ReactNode;
}

export const DialogWrapper = ({
  open,
  onOpenChange,
  onReset,
  children
}: DialogWrapperProps) => {
  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      onReset();
    }
    onOpenChange(newOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          className="w-full"
        >
          Get Started
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[95vh] w-[95vw] max-w-3xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold mb-4">
            How This Works
          </DialogTitle>
          <div className="text-gray-600 space-y-2">
            <p className="font-medium">Follow these steps:</p>
            <ol className="list-decimal list-inside space-y-2 pl-2">
              <li>Go through the step by step which will ask you for key pieces of information</li>
              <li>Copy the prompt to use in a tool of your choice</li>
              <li>Download the reference file</li>
              <li>Paste the prompt in the tool of your choice</li>
              <li>Upload the reference file</li>
              <li>Hit Enter</li>
            </ol>
          </div>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
};